import cn from 'classnames';

import type { MediaEntityType } from '@/entities/product';

import { getBulletMediaUrl, MAX_VISIBLE_THUMBNAILS } from '../../lib';

const shouldShowThumbnail = (mediaLength: number, index: number) => {
    return index < (mediaLength <= MAX_VISIBLE_THUMBNAILS ? MAX_VISIBLE_THUMBNAILS : MAX_VISIBLE_THUMBNAILS - 1);
};

type GalleryPaginationProps = Readonly<{
    media: MediaEntityType[];
    productName: string;
    onBulletClick?: (index: number) => void;
}>;

export const GalleryPagination = ({ media, productName, onBulletClick }: GalleryPaginationProps) => {
    return (
        <>
            {media.map((item, index) => {
                const showThumbnail = shouldShowThumbnail(media.length, index);
                const bulletUrl = getBulletMediaUrl(item);
                const className = cn('pdp-gallery__bullet', {
                    'pdp-gallery__bullet--play': item.type === 'video',
                });

                return (
                    <button
                        key={index}
                        type="button"
                        className={className}
                        style={{ display: showThumbnail ? 'block' : 'none' }}
                        onClick={() => onBulletClick?.(index)}
                        aria-label={`Go to ${item.type} ${index + 1}`}
                    >
                        <img
                            width="100%"
                            src={bulletUrl}
                            loading="lazy"
                            alt={`${productName} ${item.type} thumbnail ${index + 1}`}
                        />

                        {item.type === 'video' && (
                            <span className="pdp-gallery__bullet-video-icon" aria-hidden="true" />
                        )}
                    </button>
                );
            })}
        </>
    );
};
